import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store/store";
import "./registerServiceWorker";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
// import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { i18n } from "@/plugins/i18n";
import moment from "moment";
import VueScrollTo from "vue-scrollto";
import GoogleMap from "./components/Plugins/GoogleMap";
import vCheckboxOTP from '@/components/Plugins/vCheckboxOTP'
import VueMeta from 'vue-meta'
import VueCountdown from "@chenfengyuan/vue-countdown";
import JsonExcel from "vue-json-excel";
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

Vue.component(VueCountdown.name, VueCountdown);
Vue.use(VueMeta)
Vue.component("downloadExcel", JsonExcel);
Vue.component("GoogleMap", GoogleMap);
Vue.component("v-checkbox-otp", vCheckboxOTP);
Vue.use(VueScrollTo);
// Vue.use(moment);
Vue.prototype.moment = moment;
import infiniteScroll from "vue-infinite-scroll";

Vue.use(infiniteScroll);

import VuetifyConfirm from "vuetify-confirm";
Vue.use(VuetifyConfirm, {
  buttonTrueText: "OK",
  buttonFalseText: "Cancel",
  color: "black",
  icon: "warning",
  width: 300,
  property: "$confirm"
});

Vue.use(VueTimepicker);

Vue.use(Vuetify, {
  iconfont: 'md',
  theme: {
    primary: "#ffd600",
    secondary: "#EAEDED",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107",
    waiting: "#E67E22"
  }
});

export const eventBus = new Vue({
  data: {
    components: null
  },
  methods: {
    getOrderIndex(index) {
      this.$emit("indexwasGetted", index);
    }
  }
});

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render: function (h) {
    return h(App);
  }
}).$mount("#app");
